import React, { useState } from 'react'
import { useTranslation } from '@opus/web.core.hooks.use-translation'
import { getStartStyle, WrapperBox } from './sub-banner.style'
import { careStore } from '~/companies/care/care.store'
import { PATHS } from '~/common/constants'
import { Button } from '~/components/button'
import { appStore, authStore, routerStore } from '~/stores'
import { Typography } from '@material-ui/core'
import ReferrelDialogComponent from '~/features/care-referral-traveller/components/refererel.dialog'

export const SubBanner = ({ ...props }) => {
	const [open, setOpen] = useState(false)
	const { t } = useTranslation()

	const { getActiveFeature, isJTP } = careStore
	const { code } = getActiveFeature
	const isHome = code === 'home'
	if (isHome) return <></>

	return (
		<WrapperBox {...props}>
			<span className="get-started-text">{isJTP ? t('GET_STARTED_TEXT_JTP') : t('GET_STARTED_TEXT_JNP')}</span>

			<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
				<Button
					css={getStartStyle}
					onClick={() => {
						routerStore.goPage(PATHS.common.authorization)
					}}
				>
					<Typography css={appStore.getTheme.typography.button}>{t('LOG_IN')}</Typography>
				</Button>
			</div>
			<ReferrelDialogComponent
				open={open}
				setOpen={setOpen}
				isShowIcon={authStore.isAnonymous}
				buttonAction={'SHARE NOW'}
				title={'Refer Friends. Get $500 Cash Bonuses!'}
			/>
		</WrapperBox>
	)
}
